import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';

import requestsStatuses from 'modules/common/constants/requestsStatuses';
import { DynamicForm, Button, DynamicFields } from 'shared/components';

import theme from './CaseDataForm.scss';

const propTypes = {
  intl: PropTypes.object.isRequired,
  form: PropTypes.string,
  formConfig: PropTypes.array,
  initialValues: PropTypes.object,
  validate: PropTypes.func.isRequired,
  submitForm: PropTypes.func.isRequired,
  isPristine: PropTypes.bool,
  isClosed: PropTypes.bool,
  updateRequestStatus: PropTypes.string,
  editModeEnabled: PropTypes.bool.isRequired,
  setEditMode: PropTypes.func.isRequired,
  canEditCaseData: PropTypes.bool,
};

const defaultProps = {
  form: undefined,
  formConfig: undefined,
  initialValues: null,
  isPristine: true,
  isClosed: false,
  updateRequestStatus: requestsStatuses.default,
  canEditCaseData: false,
};

const CaseDataForm = ({
  intl,
  formConfig,
  isPristine,
  isClosed,
  submitForm,
  updateRequestStatus,
  editModeEnabled,
  setEditMode,
  canEditCaseData,
  ...formProps
}) => {
  const openedByDefault = isEmpty(formProps.initialValues);

  return (
    <div className={ theme.root }>
      <div className={ theme.patientCase }>
        { editModeEnabled
          ? <DynamicForm { ...formProps } fields={ formConfig } disabled={ !canEditCaseData } />
          : <DynamicFields fields={ formConfig } />
        }
      </div>

      <div className={ theme.footer }>
        <If condition={ !editModeEnabled && canEditCaseData && !isClosed }>
          <div>
            <Button
              testId="case-data-form-cancel-button"
              label={ intl.formatMessage({ id: 'General.Edit', defaultMessage: '** Edit' }) }
              size="small"
              buttonType="naked"
              iconName="pencil"
              onClick={ () => setEditMode(true) }
            />
          </div>
        </If>
        <If condition={ (editModeEnabled && !openedByDefault) || (editModeEnabled && openedByDefault && !isPristine) }>
          <div className={ theme.formControl }>
            <Button
              testId="case-data-form-cancel-button"
              label={ intl.formatMessage({ id: 'General.Cancel', defaultMessage: '** Cancel' }) }
              size="small"
              buttonType="naked"
              onClick={ () => setEditMode(false) }
              disabled={ updateRequestStatus === requestsStatuses.pending || openedByDefault }
            />
            <Button
              testId="case-data-form-save-button"
              label={ intl.formatMessage({ id: 'General.Send', defaultMessage: '** Send' }) }
              size="small"
              onClick={ submitForm }
              disabled={ isClosed }
              isLoading={ updateRequestStatus === requestsStatuses.pending }
            />
          </div>
        </If>
      </div>
    </div>
  );
};

CaseDataForm.propTypes = propTypes;
CaseDataForm.defaultProps = defaultProps;

export default CaseDataForm;
